<template>
  <EditableItem
    :terminal="true"
    :hidden="true"
    :readonly="readonly"
    :name="item.field"
    :placeholder="$label('objects.unnamed', { label: 'table' })"
    :editing="editing"
    :attributes="attributes"
    :error="error"
    v-on:focus="$emit('focus')"
    v-on:edit="$emit('edit')"
    v-on:delete="$emit('delete')"
    v-on:center="$emit('center')">
    <template v-if="editing">
      <label class="uk-flex uk-flex-column uk-margin-bottom">
        <span>{{ $label('objects.field') }} <span class="uk-text-meta"> {{ error.field('/field') }}</span></span>
        <input
          ref="field"
          class="uk-form-controls uk-inline uk-input"
          type="text"
          v-model="field"
          pattern="[a-z](?:_?[a-z0-9]+)*"
          :placeholder="$command('objects.field')"
          autofocus
          v-on:change="$emit('update', {field: 'field', value: field.trim().replace(/[\s-()+]/g, '_').replace(/__+/g, '_').toLowerCase()})"
          v-bind:disabled="readonly"
          spellcheck="false"
          autocorrect="off"
          autocapitalize="off"
          autocomplete="off">
        <p class="uk-margin-left uk-margin-small-top uk-text-right uk-text-meta
              uk-margin-remove-bottom uk-animation-fade" v-if="help">
          {{ $help('objects.field') }}
        </p>
      </label>
      <label class="uk-flex uk-flex-column uk-margin-bottom">
        <span>{{ $label('objects.table') }} <span class="uk-text-meta"> {{ error.field('/name') }}</span></span>
        <input
          ref="name"
          class="uk-form-controls uk-inline uk-input"
          type="text"
          v-model="name"
          :placeholder="$command('objects.table', { label: 'table' })"
          autofocus
          v-on:change="$emit('update', {field: 'name', value: name.trim()})"
          v-bind:disabled="readonly"
          spellcheck="false"
          autocorrect="off"
          autocapitalize="off"
          autocomplete="off">
        <p class="uk-margin-left uk-margin-small-top uk-text-right uk-text-meta
              uk-margin-remove-bottom uk-animation-fade" v-if="help">
          {{ $help('objects.table') }}
        </p>
      </label>
      <label class="uk-flex uk-flex-column uk-margin-bottom">
        <span>{{ $label('objects.prefix') }} <span class="uk-text-meta"> {{ error.field('/prefix') }}</span></span>
        <input
          ref="prefix"
          class="uk-form-controls uk-inline uk-input"
          type="text"
          v-model="prefix"
          pattern="[a-z](?:_?[a-z0-9]+)*"
          :placeholder="$command('objects.prefix')"
          autofocus
          v-on:change="$emit('update', {field: 'prefix', value: prefix.trim().replace(/[\s-()+\.]/g, '_').replace(/__+/g, '_').toLowerCase()})"
          v-bind:disabled="readonly"
          spellcheck="false"
          autocorrect="off"
          autocapitalize="off"
          autocomplete="off">
        <p class="uk-margin-left uk-margin-small-top uk-text-right uk-text-meta
              uk-margin-remove-bottom uk-animation-fade" v-if="help">
          {{ $help('objects.prefix') }}
        </p>
      </label>
    </template>
  </EditableItem>
</template>

<script>
import { mapState } from 'vuex';
import EditableItem from '@/components/canvas/EditableItem.vue';

function assign(src, dst) {
  dst.field = src.item.field || '';
  dst.name = src.item.name || '';
  dst.prefix = src.item.prefix || '';
  dst.error = {
    invalid: src.errors.length,
    msg: src.errors.length ? 'invalid data' : null,
    local: [],
    fields: new Map(),
    field(src) {
      return this.fields.get(src) ||'';
    },
  }
  for (const {property, detail} of src.errors) {
    switch (property) {
      case '/field':
      case '/name':
      case '/prefix':
        dst.error.fields.set(property, detail);
        break;
      default:
        dst.error.local.push(detail);
        break;
    }
  }
  return dst;
}

export default {
  name: 'Entity',
  props: {
    version: Number,
    item: Object,
    category: String,
    label: String,
    errors: Array,
    editing: Boolean,
    context: Object,
    categories: Object,
    attribute: String,
    references: Map,
    readonly: Boolean,
  },
  components: {
    EditableItem
  },
  data() {
    return assign(this, {});
  },
  watch: {
    version() {
      assign(this, this);
    },
  },
  computed: {
    attributes() {
      return [];
    },
    ...mapState('api', ['help']),
  },
}
</script>